(function () {
    // Header background/logo swap on scroll (transparent gradient at the top of the page, solid
    // black + inverted logo once scrolled). The actual colors live in the "site-header" utility
    // (_utility.css) and the header component's own group-[.page-scrolling] classes - this only
    // toggles the state class.
    const siteHeader = document.querySelector("[data-site-header]");
    if (siteHeader) {
        const updateHeaderScrollState = () => {
            siteHeader.classList.toggle("page-scrolling", window.scrollY > 0);
        };

        updateHeaderScrollState();
        window.addEventListener("scroll", updateHeaderScrollState, { passive: true });
    }

    // The Back button is a plain link: its target is chosen server-side for each page (see the
    // header component), so it always lands on the page's logical parent rather than wherever
    // browser history happens to point - e.g. a filtered listing, or a wizard step.
})();
